<template>
  <div>
    <div class="TabellaOperazioniRicambi">
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <tbody>
            <tr>
                <th scope="col">Codice ricambio</th>
                <th scope="col">Descrizione ricambio</th>
                <th scope="col">Unità mis.</th>
                <th scope="col">Q.tà prevista</th>
                <th scope="col">Magazzino</th>
                <th scope="col">Q.tà effettiva</th>
            </tr>
            <RicambioRiga
                v-for="ricambio in this.listaRicambi" 
                :key="ricambio.SysChiaveglobale"                 
                :ricambio="ricambio"
            >
            </RicambioRiga>              
            </tbody>
        </table>
        <div class="AddNewRow">
            <div class="Button Stroked">
            <a class="fancybox.iframe addrowpop" href="javascript:void(0)" @click="this.openModalAggiungiRicambio()">Aggiungi Ricambio</a>
            </div>
        </div>
    </div>
    <AggiungiRicambioModal 
      v-model="this.showModal" 
      :attivita="this.attivita"    
      @opened="this.openedPopUpRicambi"   
    >
    </AggiungiRicambioModal>
  </div>  
</template>

<script>
import AggiungiRicambioModal from "@/components/modals/AggiungiRicambioModal.vue";
import RicambioAttivita from "@/models/ricambioAttivita.model.js";
import RicambioRiga from "@/components/RicambioRiga.vue"
import {apiMixin} from "/mixin.js";

export default {
    name: "GrigliaRicambi",
    data(){
        return {
            listaRicambi: [],
            showModal: false,
            listaArticoliRicambi: [],
        }
    },
    props: {
        attivita: Object,
        chiaveAttivita: String
    },
    components: {
        RicambioRiga,
        AggiungiRicambioModal
    },
    mixins: [apiMixin],
    methods:{
      openModalAggiungiRicambio: function(){
        this.showModal = true;        
      },
      openedPopUpRicambi: function(){
        $('#CodiceArticoloSelModal').removeClass("select2-hidden-accessible");
        $('#CodiceArticoloSelModal').removeAttr('data-select2-id');
        $('#CodiceArticoloSelModal').select2({
          theme: "classic"
        });
      }
    },
    mounted(){
      let params = {
        GlbAttivita: this.chiaveAttivita
      };
      this.doApiCall("get", "Interventi/GetRicambi", this.$store.getters.getUtente.Token, params).then(
        (data) => {                
          if(data){
            this.listaRicambi = data.map(o => {
              return Object.assign(new RicambioAttivita(), o)
            });     
            this.$store.commit("setArticoliFornitore", this.listaRicambi);                                             
          }             
        }
      );
      this.doApiCall("get", "Articoli/GetArticoliRicambioContratto", this.$store.getters.getUtente.Token, params).then(
        (data) => {                
          if(data){
              var list = data.map(o => {
                  return Object.assign(new RicambioAttivita(), o)
              });
              this.$store.commit("setArticoliFornitore", list);                                                  
          }             
        }
      );
    }    
}
</script>